import { useCallback, useEffect, useRef, useState } from 'react';

const HIGHLIGHT_DURATION_MS = 2500;

export const useTransientHighlights = () => {
  const [highlights, setHighlights] = useState({});
  const timeoutsRef = useRef(new Set());

  useEffect(() => () => timeoutsRef.current.forEach(clearTimeout), []);

  const markHighlight = useCallback((group, id) => {
    setHighlights((prev) => ({ ...prev, [group]: new Set(prev[group]).add(id) }));
    const handle = setTimeout(() => {
      timeoutsRef.current.delete(handle);
      setHighlights((prev) => {
        const next = new Set(prev[group]);
        next.delete(id);
        return { ...prev, [group]: next };
      });
    }, HIGHLIGHT_DURATION_MS);
    timeoutsRef.current.add(handle);
  }, []);

  return { highlights, markHighlight };
};
